import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Component, OnInit, ViewChild, Inject } from '@angular/core';
import { DataManager, WebApiAdaptor, Query } from '@syncfusion/ej2-data';
import { GridComponent, PageSettingsModel, RowSelectEventArgs, SelectionSettingsModel } from '@syncfusion/ej2-angular-grids';
import { HttpErrorResponse } from '@angular/common/http';
import { FormBuilder, FormGroup } from '@angular/forms';

import { SharedFunctions } from 'src/app/shared/shared.functions';

import { UsuarioService } from 'src/app/shared/services/usuario.service';
import { RolService } from 'src/app/shared/services/rol.service';
import { EstadoService } from 'src/app/shared/services/estado.service';

import { GridPageSettings, Estado, Rol, DialogUsuarioSearchComponentRequestDto, DialogUsuarioSearchComponentResponseDto, SearchUsuariosItemDto, SearchRolRequest, SearchEstadoRequest } from 'src/app/shared/model';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-dialogUsuarioSearch',
    templateUrl: 'dialogUsuarioSearch.component.html',
    styleUrls: ['./dialogUsuarioSearch.component.css']
})

export class DialogUsuarioSearchComponent implements OnInit {

  @ViewChild('grid')
  public grid: GridComponent;
  @ViewChild('gridSelected')
  public gridSelected: GridComponent;

  public data: DataManager;
  total: number = 0;
  searchForm: FormGroup;
  rolList: Rol[];
  estadoList: Estado[];
  isValidating: boolean = false;
  isSearching: boolean = false;
  isExporting: boolean = false;
  isEstadoSearching: boolean = false;
  isRolSearching: boolean = false;
  canEdit: boolean = false;
  verSoloBloqueados: boolean = false;
  verSoloActivos: boolean = true;
  allowMultipleSelection: boolean = false;
  maxItemSelection: number = 0;
  itemsSeleccionados: SearchUsuariosItemDto[] = [];

  public pageSizes: number[];
  public pageSettings: PageSettingsModel;
  public query: Query;

  constructor(
    private dialogRef: MatDialogRef<DialogUsuarioSearchComponent>,
    @Inject(MAT_DIALOG_DATA) public input: DialogUsuarioSearchComponentRequestDto,
    private formBuilder: FormBuilder,
    private sharedFunctions: SharedFunctions,
    private rolService: RolService,
    private estadoService: EstadoService,
    private service: UsuarioService
    ) {

  }

  ngOnInit(): void {
    this.allowMultipleSelection = (this.input?.AllowMultipleSelection ?? false);
    this.maxItemSelection = (this.input?.MaxItemSelection ?? 0);

    this.loadView();
  }

  loadView() {
    this.pageSizes = GridPageSettings.PageSizeList;
    this.pageSettings = { pageCount: GridPageSettings.PageCount, pageSize: this.pageSizes[0], pageSizes: this.pageSizes };

    this.buildForm();
    this.setQueryParams();
    
    this.data = new DataManager({
      url: this.service.getSearchUrl(),
      adaptor: new WebApiAdaptor(),
      headers: [this.service.getAuthorizationHeader()]
    });

    this.getRoles();
    this.getEstados();
  }

  getRoles() {
    var r = new SearchRolRequest(null, null, true, "Nombre", null, null, true);
    this.isRolSearching = true;

    this.rolService.search(r).subscribe(data => {
      this.isRolSearching = false;
      if (data != null)
        this.rolList = data?.result;
    },
    (err: HttpErrorResponse) => {
      this.isRolSearching = false;
      this.sharedFunctions.handleError(err);
    });
  }

  getEstados() {
    var r = new SearchEstadoRequest(null, null, true, "Nombre", null, null, true);
    this.isEstadoSearching = true;

    this.estadoService.searchUsuarioEstados(r).subscribe(data => {
      this.isEstadoSearching = false;
      if (data != null)
        this.estadoList = data?.result;
    },
    (err: HttpErrorResponse) => {
      this.isEstadoSearching = false;
      this.sharedFunctions.handleError(err);
    });
  }

  getTotalSelectionText() {
    return (this.allowMultipleSelection && this.maxItemSelection > 0 ? "de " + this.maxItemSelection : "");
  }

  buildForm() {
    this.searchForm = this.formBuilder.group({
      'RolId': [null],
      'Login': [null],
      'Nombre': [null],
      'Apellido': [null],
      'NroDocumento': [null],
      'Mail': [null],
      'Movil': [null],
      'EstadoId': [null]
    });
  }

  setQueryParams() {
    if (this.query == null)
      this.query = new Query();

    var index = this.query.params.findIndex(obj => obj.key === "RolId");
    if (index >= 0)
      this.query.params[index].value = this.searchForm.value.RolId;
    else
      this.query.addParams("RolId",this.searchForm.value.RolId);
    
      index = this.query.params.findIndex(obj => obj.key === "Login");
    if (index >= 0)
      this.query.params[index].value = this.searchForm.value.Login;
    else
      this.query.addParams("Login",this.searchForm.value.Login);

    index = this.query.params.findIndex(obj => obj.key === "Nombre");
    if (index >= 0)
      this.query.params[index].value = this.searchForm.value.Nombre;
    else
      this.query.addParams("Nombre",this.searchForm.value.Nombre);

    index = this.query.params.findIndex(obj => obj.key === "Apellido");
    if (index >= 0)
      this.query.params[index].value = this.searchForm.value.Apellido;
    else
      this.query.addParams("Apellido",this.searchForm.value.Apellido);

    index = this.query.params.findIndex(obj => obj.key === "Mail");
    if (index >= 0)
      this.query.params[index].value = this.searchForm.value.Mail;
    else
      this.query.addParams("Mail",this.searchForm.value.Mail);

    index = this.query.params.findIndex(obj => obj.key === "Movil");
    if (index >= 0)
      this.query.params[index].value = this.searchForm.value.Movil;
    else
      this.query.addParams("Movil",this.searchForm.value.Movil);

    index = this.query.params.findIndex(obj => obj.key === "EstadoId");
    if (index >= 0)
      this.query.params[index].value = this.searchForm.value.EstadoId;
    else
      this.query.addParams("EstadoId",this.searchForm.value.EstadoId);

    index = this.query.params.findIndex(obj => obj.key === "VerSoloBloqueados");
    if (index >= 0)
      this.query.params[index].value = this.verSoloBloqueados ? "true":"false";
    else
      this.query.addParams("VerSoloBloqueados", this.verSoloBloqueados? "true":"false");

    index = this.query.params.findIndex(obj => obj.key === "VerSoloActivos");
    if (index >= 0)
      this.query.params[index].value = this.verSoloActivos ? "true":"false";
    else
      this.query.addParams("VerSoloActivos", this.verSoloActivos? "true":"false");
  }

  onSearch() {
    this.setQueryParams();
    this.grid.refresh();
  }

  showUserImage(item: SearchUsuariosItemDto) {
    return (item?.FotoPerfilUrl?.length > 0);
  }

  onRowSelected(args: RowSelectEventArgs) {
    if (!this.allowMultipleSelection) {
      const selectedrecords: any[] = this.grid.getSelectedRecords();

      if (selectedrecords != null && selectedrecords.length > 0)
        this.addItem(selectedrecords[0]);
    }
  }

  addItem(item: SearchUsuariosItemDto) {
    if (this.itemsSeleccionados == null)
      this.itemsSeleccionados = [];

    if (item != null && item.Id  > 0) {
      var index = this.itemsSeleccionados.findIndex(f => f.Id == item.Id);

      if (index < 0) {
        if (!this.allowMultipleSelection)
          this.itemsSeleccionados = [];
        else {
          if (this.maxItemSelection > 0 && this.itemsSeleccionados.length >= this.maxItemSelection) {
            this.sharedFunctions.showMessage("Llegaste al límite de usuarios que podes seleccionar", "Error");
            return false;
          }
        }

        this.itemsSeleccionados.push(item);
        if (this.gridSelected != null)
          this.gridSelected.refresh();
      }
    }
  }

  removeItem(item: SearchUsuariosItemDto) {
    if (this.itemsSeleccionados == null)
      this.itemsSeleccionados = [];

    if (item != null && item.Id  > 0) {
      var index = this.itemsSeleccionados.findIndex(f => f.Id == item.Id);
      if (index >= 0) {
        this.itemsSeleccionados.splice(index, 1);
        if (this.gridSelected != null)
          this.gridSelected.refresh();
      }
    }
  }

  onSelect() {
    if (this.itemsSeleccionados == null || this.itemsSeleccionados.length == 0) {
      this.sharedFunctions.showMessage("Debe seleccionar " + (this.allowMultipleSelection ? "al menos" : "") + " un usuario para continuar", "Error");
      return false;
    }

    this.dialogRef.close(new DialogUsuarioSearchComponentResponseDto(false, this.itemsSeleccionados));
  }

  onClear() {
    this.itemsSeleccionados = [];
    this.onSearch();
  }

  onCancel() {
    this.dialogRef.close(new DialogUsuarioSearchComponentResponseDto(true, null));
  }
}